import { AlphaZCircleOutlineIcon } from './AlphaZCircleOutlineIcon';

/**
 * author: Contributors
 * id 63AF9496-BE67-43F7-9DE4-341E0EDC0C62
 * name alpha-z-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-z-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetZCircleOutlineIcon = AlphaZCircleOutlineIcon;
export default AlphabetZCircleOutlineIcon